import styled from 'styled-components'

export const StepperWrapper = styled.div`
  & button {
    border-radius: 40px;
    width: 40px;
    height: 40px;
  }

  & .activated {
    background: #f4f6f9;
  }
`
